import { PortalError } from '../../../error/portal-error';

export type NewDelegationErrorCode = 'TOO_MANY_UNSTAKING_DELEGATIONS' | 'REDELEGATION_ALREADY_IN_PROGRESS';

export class NewDelegationError extends PortalError<NewDelegationErrorCode> {}
